// Blog sayfasının davranışları (React içinde çalışır): ana sayfa başlığının kaydırma/mobil menü
// davranışı (premium-landing.js'deki ile aynı), içindekiler menüsünde etkin bölüm, yukarı çık.
// Dönüş: temizlik fonksiyonu.
export default function initBlogBehavior(root) {
  const disposers = [];
  const on = (target, type, listener, options) => {
    if (!target) return;
    target.addEventListener(type, listener, options);
    disposers.push(() => target.removeEventListener(type, listener, options));
  };

  const header = root.querySelector('[data-header]');
  const toggle = root.querySelector('.menu-toggle');
  const mobileMenu = root.querySelector('.mobile-menu');
  const updateHeader = () => header?.classList.toggle('scrolled', window.scrollY > 20);
  updateHeader();
  on(window, 'scroll', updateHeader, { passive: true });
  const setMenu = (open) => {
    if (!toggle || !mobileMenu || !header) return;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    mobileMenu.classList.toggle('open', open);
    header.classList.toggle('menu-active', open);
    document.body.classList.toggle('menu-open', open);
  };
  on(toggle, 'click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  on(window, 'resize', () => { if (window.innerWidth > 1024) setMenu(false); });
  disposers.push(() => document.body.classList.remove('menu-open'));

  const contents = root.querySelector('.blog-contents');
  if (contents) {
    const links = Array.from(contents.querySelectorAll('a[href^="#"]'));
    const targets = links.map((a) => root.querySelector(`#${CSS.escape(a.getAttribute('href').slice(1))}`)).filter(Boolean);
    const setActive = (id) => links.forEach((a) => {
      if (a.getAttribute('href') === `#${id}`) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
    const update = () => {
      const current = targets.filter((el) => el.getBoundingClientRect().top <= 170).at(-1) || targets[0];
      if (current) setActive(current.id);
    };
    update();
    on(window, 'scroll', update, { passive: true });
    const tocToggle = root.querySelector('.blog-toc-toggle');
    on(tocToggle, 'click', () => {
      const open = tocToggle.getAttribute('aria-expanded') !== 'true';
      tocToggle.setAttribute('aria-expanded', String(open));
      contents.classList.toggle('is-open', open);
    });
    links.forEach((a) => on(a, 'click', (event) => {
      const target = root.querySelector(`#${CSS.escape(a.getAttribute('href').slice(1))}`);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', a.getAttribute('href'));
      }
      tocToggle?.setAttribute('aria-expanded', 'false');
      contents.classList.remove('is-open');
    }));
  }

  const top = root.querySelector('.blog-scroll-top');
  if (top) {
    const updateTop = () => top.classList.toggle('is-visible', window.scrollY > 600);
    updateTop();
    on(window, 'scroll', updateTop, { passive: true });
    on(top, 'click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  return () => disposers.splice(0).forEach((dispose) => dispose());
}
